import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NewClaim } from '../models/Claims/newClaim.model';
import { Claimant } from '../models/Claims/claimainant.model';
import { DraftandSubmittedRequest } from 'src/app/models/Requests/DraftandSubmittedRequest.model';
import { DropDownData } from '../models/dropdown.model';


@Injectable({
  providedIn: 'root'
})
export class ClaimsService {
  apiUrl: string = "Claims";
  newClaimSaveType = new BehaviorSubject<string>("");
  constructor(private http: HttpClient) {

  }
  draftClaimTab = new BehaviorSubject<string>("");
  saveNewClaim(claim: NewClaim, saveType: string): Observable<string> {
    let args = {
      newClaim: claim,
      saveType: saveType
    };

    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(args);
    return this.http.post<string>(environment.baseUrl + this.apiUrl + '/newclaim',
      body, { headers: headers });
  }
  saveNewDISDClaim(claim:NewClaim,saveType:string):Observable<string>{
    let args={
      newClaim:claim,
      saveType:saveType
    };
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(args);
    return this.http.post<string>(environment.baseUrl + this.apiUrl + '/newDISDclaim',
      body, { headers: headers });
  }
  GetClaimainants(claimId: number): Observable<Claimant> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(claimId);
    return this.http.post<Claimant>(environment.baseUrl + this.apiUrl + '/GetClaimainantNames',
      body, { headers: headers });
  }

  GetClaimainantDetails(studentID?: number) {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(studentID);
    return this.http.post<Claimant>(environment.baseUrl + this.apiUrl + '/GetClaimainantDetails',
      body, { headers: headers });
  }

  getDraftClaims(request: DraftandSubmittedRequest): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(request);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/DraftClaims',
      body, { headers: headers }).pipe(map(data => {
        return data.body;
      }));
  }

  getSubmittedClaims(request: DraftandSubmittedRequest): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(request);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/SubmittedClaims',
      body, { headers: headers }).pipe(map(data => {
        return data.body;
      }));
  }

  GetDropdownData(): Observable<DropDownData> {
    const headers = { 'content-type': 'application/json' }
    return this.http.post<DropDownData>(environment.baseUrl + this.apiUrl + '/DropdownData', { headers: headers });
  }

  DeleteClaim(claimId: number): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(claimId);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/DeleteClaim', body, { headers: headers });
  }
  DeleteDISDClaim(claimId: number): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(claimId);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/DeleteDISDClaim', body, { headers: headers });
  }
  LoadClaimForm(claimId: number): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(claimId);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/LoadClaimForm', body, { headers: headers }); 
  }
  LoadDISDClaimForm(claimId: number): Observable<any>{
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(claimId);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/LoadDISDClaimForm', body, { headers: headers }); 
  }
  getDISDSubmittedClaims(request: DraftandSubmittedRequest): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(request);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/DISDSubmittedClaims',
      body, { headers: headers }).pipe(map(data => {
        return data.body;
      }));
  }
  getDISDDraftClaims(request: DraftandSubmittedRequest): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(request);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/DISDDraftClaims',
      body, { headers: headers }).pipe(map(data => {
        return data.body;
      }));
  }
  getPrintClaimCSS(){
    return this.http.get('./assets/view-claims.css',{ responseType: 'text' });
  }
}
